import React, {Component} from 'react';
import {Button, ControlLabel, FormControl, FormGroup, Modal} from 'react-bootstrap';
import ErrorMessageContainer from './ErrorMessageContainer';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import axios from 'axios';
import Utils from "./Utils";
import DecimalHelpBlock from "./DecimalHelpBlock";

require('moment/locale/el');

const InvoiceHistoryAttachmentLink = ({link}) => {
    if (!link) {
        return null;
    }

    return (
        <a target="_blank" href={link}>
            <i className="fa fa-cloud-download"></i> {window.__js_contracts.download_current_file}
        </a>
    );
};

export default class ContractInvoicesHistoryModal extends Component {
    constructor() {
        super();

        this.state = {
            validationErrors: [],
            submitDisabled: false,
            invoice_id: 0,
            invoice_date: moment(),
            invoice_amount: "",
            invoice_vat: "",
            invoice_amount_vat: "",
            attachment_url: null,
        };

        this.attachmentInputRef = React.createRef();

        this.handleInvoiceDateChange = this.handleInvoiceDateChange.bind(this);
        this.handleInvoiceAmountChange = this.handleInvoiceAmountChange.bind(this);
        this.handleInvoiceAmountVatChange = this.handleInvoiceAmountVatChange.bind(this);
        this.submit = this.submit.bind(this);
        this.close = this.close.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id !== 0) {
            const url = this.props.type === 'contract'
                ? "/contracts/ajax/manage_contracts/" + this.props.contractId + "/invoice_history/" + nextProps.id
                : "/contracts/ajax/expenditures/" + this.props.contractId + "/invoice_history/" + nextProps.id;

            this.setState({
                validationErrors: [],
                submitDisabled: true
            }, () => {
                axios
                    .get(url)
                    .then((response) => {
                        let history = response.data;
                        let invoice_date = moment();

                        if (history.invoice_date_formatted === null)
                            invoice_date = moment();
                        else if (history.invoice_date_formatted === "")
                            invoice_date = "";
                        else
                            invoice_date = moment(history.invoice_date_formatted, "DD/MM/YYYY");

                        this.setState({
                            validationErrors: [],
                            submitDisabled: false,
                            invoice_id: history.id,
                            invoice_date: invoice_date,
                            invoice_amount: history.invoice_amount_comma,
                            invoice_vat: history.invoice_vat_comma,
                            invoice_amount_vat: history.invoice_amount_vat_comma,
                            attachment_url: history.attachment_url || null,
                        });
                    });
            });
        } else {
            this.setState({
                validationErrors: [],
                submitDisabled: false,
                invoice_id: 0,
                invoice_date: moment(),
                invoice_amount: "",
                invoice_vat: "",
                invoice_amount_vat: "",
                attachment_url: null,
            });
        }
    }

    handleInvoiceDateChange(date) {
        this.setState({invoice_date: date});
    }

    handleInvoiceAmountChange(e) {
        let value = Utils.handleDecimals(e.target.value);
        let vat = parseFloat(this.state.invoice_vat.replace(',', '.'));
        let amount_vat = ((vat !== '') ? Utils.calculateAmountVATFromVAT(vat, value) : '');

        this.setState({
            invoice_amount: value,
            invoice_amount_vat: amount_vat,
        });
    }

    handleInvoiceAmountVatChange(e) {
        let value = Utils.handleDecimals(e.target.value);
        let amount = this.state.invoice_amount;
        let vat = parseFloat(e.target.value.replace(",", "."));
        let invoice_amount = ((amount !== '') ? Utils.calculateAmountVATFromVAT(vat, amount) : '');

        this.setState({
            invoice_vat: value,
            invoice_amount_vat: invoice_amount,
        });
    }

    submit() {
        if (!this.state.submitDisabled) {
            this.setState({
                validationErrors: [],
                submitDisabled: true
            }, () => {
                const url = this.props.type === 'contract'
                    ? "/contracts/ajax/manage_contracts/" + this.props.contractId + "/invoice_history/" + this.state.invoice_id
                    : "/contracts/ajax/expenditures/" + this.props.contractId + "/invoice_history/" + this.state.invoice_id;

                const invoiceDate = this.state.invoice_date !== "" ? this.state.invoice_date.format("DD/MM/YYYY") : "";
                const file = this.attachmentInputRef.current.files[0];
                const formData = new FormData();
                formData.append('invoice_date', invoiceDate);
                formData.append('invoice_amount', this.state.invoice_amount);
                formData.append('invoice_vat', this.state.invoice_vat);

                if (file) {
                    formData.append('attachment', file);
                }

                axios
                    .post(url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        this.setState({
                            submitDisabled: false
                        }, () => {
                            this.close();
                        });
                    })
                    .catch((failure) => {
                        this.setState({
                            validationErrors: failure.response.data,
                            submitDisabled: false
                        });
                    });
            });
        }
    }

    close() {
        this.props.closeCallback();
    }

    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.close}>
                <Modal.Header closeButton>
                    <Modal.Title>{window.__js_contracts.billing_tracking}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorMessageContainer errors={this.state.validationErrors}/>

                    <FormGroup controlId="invoice_date">
                        <ControlLabel>{window.__js_general.date}*</ControlLabel>
                        <DatePicker className="form-control"
                                    name="invoice_date"
                                    id="invoice_date"
                                    selected={this.state.invoice_date}
                                    onChange={this.handleInvoiceDateChange}
                                    dateFormat="DD/MM/YYYY"
                                    locale="el"/>
                    </FormGroup>

                    <FormGroup controlId="invoice_amount">
                        <ControlLabel>{window.__js_contracts.amount}*</ControlLabel>
                        <FormControl type="text"
                                     value={this.state.invoice_amount}
                                     name="invoice_amount"
                                     id="invoice_amount"
                                     onChange={this.handleInvoiceAmountChange}/>
                        <DecimalHelpBlock/>
                    </FormGroup>

                    <FormGroup controlId="invoice_vat">
                        <ControlLabel>{window.__js_contracts.vat_rate}*</ControlLabel>
                        <FormControl type="text"
                                     value={this.state.invoice_vat}
                                     name="invoice_vat"
                                     id="invoice_vat"
                                     onChange={this.handleInvoiceAmountVatChange}/>
                        <DecimalHelpBlock/>
                    </FormGroup>

                    <FormGroup controlId="invoice_amount_vat">
                        <ControlLabel>{window.__js_contracts.amount_with_vat}*</ControlLabel>
                        <FormControl type="text"
                                     readOnly
                                     value={this.state.invoice_amount_vat}
                                     name="invoice_amount_vat"
                                     id="invoice_amount_vat"
                        />
                    </FormGroup>

                    <FormGroup controlId="attachment">
                        <ControlLabel>{window.__js_contracts.attached_file}</ControlLabel>
                        <input
                            type="file"
                            className="form-control"
                            name="attachment"
                            id="attachment"
                            ref={this.attachmentInputRef}
                        />
                        <InvoiceHistoryAttachmentLink link={this.state.attachment_url}/>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.submit} bsStyle="primary"
                            disabled={this.state.submitDisabled}>{window.__js_general.save}</Button>
                    <Button onClick={this.close}>{window.__js_general.close}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}